export default "__VITE_ASSET__Ca40blQh__"